import { ILookup } from './lookup';

export class SortOrderOptions implements ILookup<string> {
  id: string;
  description: string;

  static ascending: SortOrderOptions = { id: 'Asc', description: 'Ascending' };
  static descending: SortOrderOptions = { id: 'Desc', description: 'Descending' };

  static get options(): ILookup<string>[] {
    return [ SortOrderOptions.ascending, SortOrderOptions.descending ];
  }
}